import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Cell,
  Tooltip,
  LabelList, // 1. Importamos LabelList
} from "recharts";

export default function MonthlyCustomerChart({ data = [] }) {
  const chartData = data.map((r) => ({
    ...r,
    prInput: Number(r.prInput),
    shortLabel: `${r.prNameMonth.substring(0, 3)} ${String(r.prYear).slice(-2)}`,
    fullLabel: `${r.prNameMonth} ${r.prYear}`,
    prNos: Number(r.prNos)
  }));

  const colors = [
    "#3B82F6", // Enero (Blue)
    "#10B981", // Febrero (Emerald)
    "#F59E0B", // Marzo (Amber)
    "#EF4444", // Abril (Red)
    "#8B5CF6", // Mayo (Violet)
    "#06B6D4", // Junio (Cyan)
    "#EC4899", // Julio (Pink)
    "#F97316", // Agosto (Orange)
    "#84CC16", // Septiembre (Lime)
    "#6366F1", // Octubre (Indigo)
    "#14B8A6", // Noviembre (Teal)
    "#A855F7", // Diciembre (Purple)
  ];
  return (
    <div className="w-full h-full flex items-center justify-center">
      <ResponsiveContainer width="100%" height={120}>
        <BarChart
          data={chartData}
          barCategoryGap={2}
          /* 2. Añadimos un poco de margen superior para que el número quepa sobre la barra */
          margin={{ top: 15, right: 0, left: 0, bottom: 0 }}
        >
          <XAxis
            dataKey="shortLabel"
            // 1. Aumentamos el height del eje para separar los textos de las barras
            height={30}
            tick={{ fontSize: 8, fill: "#6B7280", fontWeight: 600 }}
            axisLine={false}
            tickLine={false}
            interval={0}
            // 2. Agregamos padding para que la primera y última barra no peguen con los bordes
            padding={{ left: 0, right: 0 }}
          />

          <YAxis hide domain={[0, 'dataMax + 5']} /> {/* 3. Ajustamos el dominio para dar espacio visual arriba */}

          <Tooltip
            cursor={{ fill: '#F3F4F6', opacity: 0.4 }}
            content={({ active, payload }) => {
              if (active && payload && payload.length) {
                return (
                  <div className="bg-white border border-gray-200 px-3 py-2 rounded-lg shadow-xl text-[10px]">
                    <p className="font-bold text-gray-800 border-b border-gray-100 mb-1">
                      {payload[0].payload.fullLabel}
                    </p>
                    <p className="text-gray-600">
                      Ordenado: <span className="font-bold text-gray-900">{payload[0].value}</span>
                    </p>
                    <p className="text-gray-600">
                      Nro de Ordenes: <span className="font-bold text-gray-900">{payload[0].payload.prNos}</span>
                    </p>
                  </div>
                );
              }
              return null;
            }}
          />

          <Bar
            dataKey="prInput"
            radius={[4, 4, 0, 0]}
            barSize={20}
          >
            {/* 4. Esta es la clave: LabelList renderiza el valor automáticamente */}
            <LabelList
              dataKey="prInput"
              position="top"
              style={{ fontSize: '9px', fontWeight: 'bold', fill: '#374151' }}
            />

            {chartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
                fillOpacity={0.8}
                stroke={colors[index % colors.length]}
                strokeWidth={1}
                className="hover:fill-opacity-100 transition-all duration-300"
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}